/**
 * BabyBjörn tab module — ARIA tabs + sliding indicator.
 */
(function () {
  function initRoot(root) {
    if (!root || root.dataset.bbjTabsBound === '1') return;

    const tablist = root.querySelector('.babybjorn-tabs__tablist');
    if (!tablist) return;

    const tabs = Array.from(tablist.querySelectorAll('.babybjorn-tabs__tab[role="tab"]'));
    const panels = tabs.map(function (tab) {
      const id = tab.getAttribute('aria-controls');
      return id ? document.getElementById(id) : null;
    });
    const indicator = root.querySelector('.babybjorn-tabs__indicator-bar');
    const mediaItems = Array.from(root.querySelectorAll('[data-bbj-tabs-media]'));
    let activeIndex = Math.max(
      0,
      tabs.findIndex(function (t) {
        return t.getAttribute('aria-selected') === 'true';
      })
    );

    function moveIndicator() {
      if (!indicator || !tabs[activeIndex]) return;
      const tab = tabs[activeIndex];
      const listRect = tablist.getBoundingClientRect();
      const tabRect = tab.getBoundingClientRect();
      const left = tabRect.left - listRect.left + tablist.scrollLeft;
      indicator.style.width = tabRect.width + 'px';
      indicator.style.transform = 'translateX(' + left + 'px)';
    }

    function selectTab(index, shouldFocus) {
      if (index < 0 || index >= tabs.length) return;
      activeIndex = index;
      tabs.forEach(function (tab, i) {
        var on = i === index;
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
        if (panels[i]) {
          if (on) {
            panels[i].removeAttribute('hidden');
          } else {
            panels[i].setAttribute('hidden', '');
          }
        }
      });
      mediaItems.forEach(function (media, i) {
        var on = i === index;
        media.classList.toggle('is-active', on);
        if (on) {
          media.removeAttribute('aria-hidden');
        } else {
          media.setAttribute('aria-hidden', 'true');
        }
      });
      moveIndicator();
      if (shouldFocus && tabs[index]) {
        tabs[index].focus({ preventScroll: true });
      }
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        selectTab(i, false);
      });
    });

    tablist.addEventListener('keydown', function (e) {
      const last = tabs.length - 1;
      var next = activeIndex;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
        e.preventDefault();
        next = activeIndex >= last ? 0 : activeIndex + 1;
      } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
        e.preventDefault();
        next = activeIndex <= 0 ? last : activeIndex - 1;
      } else if (e.key === 'Home') {
        e.preventDefault();
        next = 0;
      } else if (e.key === 'End') {
        e.preventDefault();
        next = last;
      } else {
        return;
      }
      selectTab(next, true);
    });

    tablist.addEventListener('scroll', function () {
      moveIndicator();
    });

    window.addEventListener(
      'resize',
      function () {
        moveIndicator();
      },
      { passive: true }
    );

    root.dataset.bbjTabsBound = '1';
    selectTab(activeIndex, false);
    requestAnimationFrame(moveIndicator);
  }

  function initAll(container) {
    (container || document).querySelectorAll('[data-bbj-tabs-root]').forEach(initRoot);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) {
      initAll(e.target);
    }
  });
})();
